import { Skeleton } from "@mantine/core";
import { useStatusStore } from "@utils/stores/useStatusStore.ts";
import { useTaxProAnalytics } from "@utils/hooks/useAnalytics.ts";
import FilterChipsGroup from "../FilterChipsGroup/FilterChipsGroup.tsx";
import FilterChip from "../FilterChip/FilterChip.tsx";
import { ORGANIZER_STATUS_CONFIG } from "../../ClientListTable/utils/badgeUtils";
import React from "react";

// Define organizer statuses using centralized config
const organizerStatuses = [
  {
    id: 1,
    text: ORGANIZER_STATUS_CONFIG["not started"].text,
    value: "not started",
    color: ORGANIZER_STATUS_CONFIG["not started"].color,
    textColor: ORGANIZER_STATUS_CONFIG["not started"].textColor,
    icon: React.cloneElement(ORGANIZER_STATUS_CONFIG["not started"].icon, {
      size: 20,
    }),
  },
  {
    id: 2,
    text: ORGANIZER_STATUS_CONFIG["in progress"].text,
    value: "in progress",
    color: ORGANIZER_STATUS_CONFIG["in progress"].color,
    textColor: ORGANIZER_STATUS_CONFIG["in progress"].textColor,
    icon: React.cloneElement(ORGANIZER_STATUS_CONFIG["in progress"].icon, {
      size: 20,
    }),
  },
  {
    id: 3,
    text: ORGANIZER_STATUS_CONFIG.complete.text,
    value: "complete",
    color: ORGANIZER_STATUS_CONFIG.complete.color,
    textColor: ORGANIZER_STATUS_CONFIG.complete.textColor,
    icon: React.cloneElement(ORGANIZER_STATUS_CONFIG.complete.icon, {
      size: 20,
    }),
  },
];

const OrganizerStatusFilterChips = () => {
  const { clickedOrganizerStatus, setClickedOrganizerStatus } =
    useStatusStore();
  const { organizerStatuses: organizerStatusCounts, isLoadingAnalytics } =
    useTaxProAnalytics();

  const handleStatusClick = (statusValue: string, count: number) => {
    // Don't allow clicking if count is 0
    if (count === 0) return;
    setClickedOrganizerStatus(
      clickedOrganizerStatus === statusValue ? null : statusValue
    );
  };

  if (isLoadingAnalytics) {
    return (
      <FilterChipsGroup data-testid="organizer-status-filter-chips-loading">
        {[1, 2, 3].map((i) => (
          <Skeleton key={i} height={36} width={140} radius="xl" />
        ))}
      </FilterChipsGroup>
    );
  }

  return (
    <FilterChipsGroup data-testid="organizer-status-filter-chips">
      {organizerStatuses.map((status) => {
        const isActive = clickedOrganizerStatus === status.value;
        const count = organizerStatusCounts?.[status.value] || 0;
        const isDisabled = count === 0;

        return (
          <FilterChip
            key={status.id}
            isActive={isActive}
            color={status.color}
            icon={status.icon}
            onChange={() => handleStatusClick(status.value, count)}
            disabled={isDisabled}
            data-testid={`organizer-status-chip-${status.value}`}
            customStyles={{
              label: {
                color: isActive ? status.textColor : "#333",
              },
            }}
          >
            {status.text} ({count})
          </FilterChip>
        );
      })}
    </FilterChipsGroup>
  );
};

export default OrganizerStatusFilterChips;
